module.exports = __webpack_public_path__ + "static/media/pen-edit.90915f77.svg";